export default "__VITE_ASSET__NGJTF6aX__"